import React from "react";
import estados from "../../services/estados";
import api from "../../services/api";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import { store } from "react-notifications-component";
import GenericUpper from "../../components/generic-upper";
import { DevolucaoAddContainer } from "./styles";
import { Container } from "react-grid-system";
import Input from "../../components/input/input_v2";
import Select from "../../components/select/select_v2";
import Button from "../../components/button/button_v2";
import buscaCep from "../../services/buscaCep";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";

class EditDevolucao extends React.Component {
    state = {
        nome: "",
        cnpj: "",
        estado: "",
        cep: "",
        telefone: "",
        celular: "",
        responsavel: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        id: "",
        OpStatus: [{ value: 1, label: "Ativo" }, { value: 0, label: "Inativo" }],
        status: "",
        filiais: [],
        filial: [],
        loading: false,

        erroFilial: false,
        erroFilialMsg: '',
        
        erroBairro: false,
        erroBairroMsg: '',
        
        erroCep: false,
        erroCepMsg: '',

        erroCidade: false,
        erroCidadeMsg: '',

        erroEndereco: false,
        erroEnderecoMsg: '',

        erroEstado: false,
        erroEstadoMsg: '',

        erroNome: false,
        erroNomeMsg: '',

        erroCnpj: false,
        erroCnpjMsg: '',

        erroNumero: false,
        erroNumeroMsg: '',

        erroStatus: false,
        erroStatusMsg: '',

        loadingCep: false,
    };

    formatCnpj = (valor = "") => {
        let value = String(valor).replace(/\D/g, "");
        value = value.slice(0, 14);
        value = value.replace(/^(\d{2})(\d)/, "$1.$2");
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
        value = value.replace(/(\d{4})(\d)/, "$1-$2");
        return value;
    };

    // Consulta o microserviço de validação (com fallback local se ele não
    // responder). Retorna { valido, erro } — cnpj fora do padrão nem chega a
    // consultar o serviço.
    isValidCnpj = async (valor = "") => {
        const cnpj = String(valor).replace(/\D/g, "");
        if (!cnpj || cnpj.length !== 14) return { valido: false, erro: null };
        return validadorCpfCnpj(cnpj);
    };

    validateCnpj = (valor) => {
        this.setState({
            cnpj: this.formatCnpj(valor),
            erroCnpj: false,
            erroCnpjMsg: "",
        });
    };

    validaCNPJ = async (valor) => {
        const hasValue = String(valor || "").replace(/\D/g, "").length > 0;
        if (!hasValue) {
            this.setState({ erroCnpj: false, erroCnpjMsg: "" });
            return;
        }

        const resultado = await this.isValidCnpj(valor);
        this.setState({
            erroCnpj: !resultado.valido,
            erroCnpjMsg: resultado.valido ? "" : (resultado.erro || "Informe um CNPJ válido."),
        });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getDevolucoes();
        this.getFiliais();
    }

    getFiliais = async () => {

        let filiais = [];
        try {
            const response = await api.get("/filiais");
            filiais = response.data.data;

            const formatFiliais = filiais.map(f => {
                let format = {
                    value: f.id,
                    label: f.nome_fantasia
                };
                return format;
            });            
            
            if (filiais && filiais.length > 0) {                
                this.setState({ filiais: formatFiliais });
            } else {
                this.setState({ filiais: formatFiliais });

            }
        } catch (e) {
            if(filiais.id && filiais.nome_fantasia){
                filiais = [
                    {
                        value: filiais.id,
                        label: filiais.nome_fantasia 
                    }
                ]
                this.setState({ filiais });
            }
            this.setState({ loading: false });
        }
    };

    editPost = async e => {
        this.setState({ loading: true });
        const {
            nome,
            cnpj,
            estado,
            cep,
            complemento,
            numero,
            telefone,
            celular,
            responsavel,
            endereco,
            bairro,
            cidade,
            id,
            status,
            filial

        } = this.state;

        const hasCnpj = String(cnpj || "").replace(/\D/g, "").length > 0;
        const resultadoCnpj = hasCnpj ? await this.isValidCnpj(cnpj) : { valido: true };
        if (hasCnpj && !resultadoCnpj.valido) {
            this.setState({
                loading: false,
                erroCnpj: true,
                erroCnpjMsg: resultadoCnpj.erro || "Informe um CNPJ válido.",
            });

            store.addNotification({
                title: "Erro!",
                message: resultadoCnpj.erro || "Informe um CNPJ válido.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return;
        }

        const payload = {
            nome,
            cnpj,
            estado,
            cep,
            complemento,
            numero,
            telefone,
            celular,
            responsavel,
            endereco,
            bairro,
            cidade,
            agro_subsidiary_id: filial,
            status
        };

        try {
            const response = await api.put(`/devolucoes/${id}/`, payload);

            if (response.status === 200) {
                this.setState({ loading: false });
                this.props.history.push("/devolucoes");
                store.addNotification({
                    title: "Sucesso!",
                    message: "O local de devolução foi Editado corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        } catch (err) {
            this.setState({ loading: false });

            this.setState({
                erroFilial: false,
                erroBairro: false,
                erroCep: false,
                erroCidade: false,
                erroEndereco: false,
                erroEstado: false,
                erroNome: false,
                erroCnpj: false,
                erroNumero: false,
                erroStatus: false
            });

            const errors = err.response.data.errors;

            for (let field in errors) {
                if ( field === 'agro_subsidiary_id'){
                    this.setState({
                        erroFilial: true,
                        erroFilialMsg: 'O campo não pode estar em branco',
                    });
                } else if ( field === 'bairro'){
                    this.setState({
                        erroBairro: true,
                        erroBairrolMsg: 'O campo não pode estar em branco',
                    });
                }else if ( field === 'cep'){
                    this.setState({
                        erroCep: true,
                        erroCepMsg: 'O campo não pode estar em branco',
                    });
                }else if ( field === 'cidade'){
                    this.setState({
                        erroCidade: true,
                        erroCidadeMsg: 'O campo não pode estar em branco',
                    });
                }else if ( field === 'endereco'){
                    this.setState({
                        erroEndereco: true,
                        erroEnderecoMsg: 'O campo não pode estar em branco',
                    });
                }else if ( field === 'estado'){
                    this.setState({
                        erroEstado: true,
                        erroEstadoMsg: 'O campo não pode estar em branco',
                    });
                }else if ( field === 'nome'){
                    this.setState({
                        erroNome: true,
                        erroNomeMsg: 'O campo não pode estar em branco',

                    });
                }else if ( field === 'cnpj'){
                    this.setState({
                        erroCnpj: true,
                        erroCnpjMsg: 'Informe um CNPJ válido.',
                    });
                }else if ( field === 'numero'){
                    this.setState({
                        erroNumero: true,
                        erroNumeroMsg: 'O campo não pode estar em branco',

                    });
                }else if ( field === 'status'){
                    this.setState({
                        erroStatus: true,
                        erroStatusMsg: 'O campo não pode estar em branco',
                    });
                }
            }

            store.addNotification({
                title: "Erro!",
                message: "Verifique os campos em vermelho",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    cangeCep = (e) => {
        this.setState({ cep: e, erroCep: false });
    }

    fetchCep = async (cep) => {

        this.setState({ loadingCep: true });
        
        try {

            const responseCep = await buscaCep(cep);
            const { logradouro, bairro, localidade, uf } = responseCep;

            this.setState({
                endereco: logradouro,
                erroEndereco: false,

                bairro,
                erroBairro: false,

                cidade: localidade,
                erroCidade: false,

                estado: uf,
                erroEstado: false,
            });

        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),  
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            this.setState({ loadingCep: false, erroCep: true, erroCepMsg: err.message });

        }

        this.setState({ loadingCep: false });
    };

    getDevolucoes = async () => {
        try {
            const id = this.props.match.params.id;
            this.setState({ id });
    
            const response = await api.get(`/devolucoes/${id}`);
            const devolucoes = response.data.data;
    
            const {
                nome,
                cnpj,
                estado,
                cep,
                complemento,
                numero,
                telefone,
                celular,
                responsavel,
                endereco,
                bairro,
                cidade,
                status,
    
            } = devolucoes;
    
            this.setState({
                nome,
                cnpj: this.formatCnpj(cnpj || ""),
                estado,
                cep,
                complemento,
                numero,
                telefone,
                celular,
                responsavel,
                endereco,
                bairro,
                cidade,
                status,
                filial: devolucoes.filial.id 
    
            });
        } catch (error) {
            if(error.response.status == 500){
                window.location = '/login';
            }
        }
    };

    onKeyDownFormater = (e, campo) => {
        if(e.keyCode === 8) {
            const value = document.getElementsByName(campo);
            return value[0].value;
        }
    };

    back = () => {
        this.props.history.goBack();
    }


    render() {
        const {
            nome,
            estado,
            endereco,
            numero,
            complemento,
            bairro,
            cidade,
            cep,
            responsavel,
            cnpj,
            telefone,
            celular,
        } = this.state;

        return (
            <>
                <GenericUpper
                    title="Edite um local de devolução"
                    subtitle="Edite este local de devolução"
                ></GenericUpper>

                <DevolucaoAddContainer>
                    <Container>
                        <form>
                            <Input
                                marginBottom="4px"
                                name="nome"
                                type="text"
                                label="Nome"
                                value={nome}
                                id="id_nome"
                                onChange={e => this.setState({ nome: e, erroNome: false })}
                                erro={this.state.erroNome}
                                messageErro={this.state.erroNomeMsg}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="cnpj"
                                label='CNPJ'
                                id="id_cnpj"
                                value={cnpj}
                                onChange={e => this.validateCnpj(e)}
                                onBlur={e => this.validaCNPJ(e.target.value)}
                                inputmode="numeric"
                                erro={this.state.erroCnpj}
                                messageErro={this.state.erroCnpjMsg}
                            />

                            <Input
                                marginBottom="4px"
                                name="responsavel"
                                type="text"
                                label="Responsável"
                                value={responsavel}
                                id="id_responsavel"
                                onChange={e => this.setState({ responsavel: e })}
                            />

                            <Select 
                                marginBottom="36px"
                                name="filial"
                                className="select"
                                label="Filial"
                                id="id_agro_subsidiary_id"
                                value={this.state.filial}
                                onChange={f => this.setState({ filial: f.value, erroFilial: false })}
                                options={this.state.filiais}
                                disabled={false}
                                erro={this.state.erroFilial}
                                messageErro={this.state.erroFilialMsg}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="telefone"
                                type="text"
                                label="Telefone"
                                id="id_telefone"
                                value={telefone}
                                onChange={e => this.setState({ telefone: e })}
                            />

                            <Input
                                marginBottom="4px"
                                name="celular"
                                type="text"
                                label="Celular"
                                id="id_celular"
                                value={celular}
                                onChange={e => this.setState({ celular: e })}
                            />

                            <Input
                                marginBottom="4px"
                                name="cep"
                                type="text"
                                label="CEP"
                                id="id_cep"
                                value={cep}
                                onChange={e => this.cangeCep(e)}
                                onBlur={(e) => this.fetchCep(e.target.value)}
                                erro={this.state.erroCep}
                                messageErro={this.state.erroCepMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="endereco"
                                type="text"
                                label="Endereço"
                                id="id_endereco"
                                value={endereco}
                                onChange={e => this.setState({ endereco: e, erroEndereco: false })}
                                erro={this.state.erroEndereco}
                                messageErro={this.state.erroEnderecoMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="numero"
                                label="Número"
                                id="id_numero"
                                value={numero}
                                onChange={e => {
                                    this.setState({ numero: e, erroNumero: false })
                                    if(e == ""){
                                        this.setState({ numero: ""})
                                    }
                                }}
                                erro={this.state.erroStatus}
                                messageErro={this.state.erroStatusMsg}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="complemento"
                                type="text"
                                label="Complemento"
                                id="id_complemento"
                                value={complemento}
                                onChange={e => this.setState({ complemento: e })}
                            />

                            <Input
                                marginBottom="4px"
                                name="bairro"
                                type="text"
                                label="Bairro"
                                id="id_bairro"
                                value={bairro}
                                onChange={e => this.setState({ bairro: e, erroBairro: false })}
                                erro={this.state.erroBairro}
                                messageErro={this.state.erroBairroMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <Input
                                marginBottom="4px"
                                name="cidade"
                                type="text"
                                label="Cidade"
                                id="id_cidade"
                                value={cidade}
                                onChange={e => this.setState({ cidade: e, erroCidade: false })}
                                erro={this.state.erroCidade}
                                messageErro={this.state.erroCidadeMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.loadingCep}
                                labelWithAsterisk
                            />

                            <Select
                                marginBottom="24px"
                                name="estado"
                                className="select"
                                label="Estado"
                                id="id_estado"
                                value={estado}
                                onChange={state => this.setState({ estado: state.value, erroEstado: false })}
                                options={estados}
                                estado={true}
                                erro={this.state.erroEstado}
                                messageErro={this.state.erroEstadoMsg}
                                loading={this.state.loadingCep}
                                disabled={this.state.estado.value || this.state.estado ? true : false}
                                labelWithAsterisk
                            />

                            <Select
                                marginBottom="4px"
                                name="status"
                                value={this.state.status}
                                type="text"
                                label="Status"
                                id="id_status"
                                onChange={status => this.setState({ status: status.value, erroStatus: false })}
                                options={this.state.OpStatus}
                                disabled={false}
                                erro={this.state.erroStatus}
                                messageErro={this.state.erroStatusMsg}
                                labelWithAsterisk
                            />

                            <div id="id_a" style={{
                                height: '0px',
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                                alignItems: 'center',
                                marginTop: '60px',
                            }}>
                                    <Button 
                                        width='45%'
                                        height='50px'
                                        value='VOLTAR'
                                        outline={true}
                                        disabled={false}
                                        onClick={() => this.back()}
                                        loading={false}
                                    />

                                    <Button 
                                        width='45%'
                                        height='50px'
                                        value='SALVAR'
                                        outline={false}
                                        disabled={false}
                                        onClick={() => this.editPost()}
                                        loading={this.state.loading}
                                    />
                            </div>
                        </form>
                    </Container>
                </DevolucaoAddContainer>
            </>
        );
    }
}

export default EditDevolucao;
